import HeaderFooterLayout from 'layouts/HeaderFooterLayoutNew';
import React from 'react';
import BillingInfo from '../components/HomePageNew/BillingInfo';
const BillingInfoPageNew = ({ ...props }) => {
  return (
    <div>
      <HeaderFooterLayout>
        <BillingInfo {...props} />
      </HeaderFooterLayout>
    </div>
  );
};

export default BillingInfoPageNew;